import React, { useEffect, useState } from 'react';
import styles from './Palindrome.module.css';
import { callAI } from '../../api-calls/ai-call';
import LoadingButton from './LoadingButton';
import ChatBubble from './ChatBubble';

function ChatAI() {
  const [callMade, setCallMade] = useState(false);
  const [question, setQuestion] = useState('');
  const [delayAPICall, setDelayAPICall] = useState(false);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    //if they change the question, lets reset the answer
    setCallMade(false);
  }, [question]);

  const executeAiCall = async () => {
    const addedQuestion = [{ side: 'right', message: question }, ...messages];
    try {
      if (!delayAPICall && !callMade && question) {
        setMessages(addedQuestion);
        // await setTimeout(() => console.log('done'), 1000);
        const response = await callAI(question);
        const addedResponse = [
          { side: 'left', message: response.message },
          ...addedQuestion,
        ];
        setMessages(addedResponse);
        // setAiResponse(response.message);
        setCallMade(true);

        setDelayAPICall(true);
        setTimeout(() => {
          setDelayAPICall(false);
        }, 500);
      }
    } catch (e) {
      setMessages([
        {
          side: 'left',
          type: 'error',
          message: 'An issue has occurred reaching out',
        },
        ...addedQuestion,
      ]);
      setError('something went wrong communicating with the AI');
    }
  };

  return (
    <div className={styles.palindromeContainer}>
      <div className={styles.inputsContainer}>
        <input
          className={styles.input}
          onChange={(e) => setQuestion(e.target.value)}
          type="text"
          maxLength="100"
          placeholder="example: Does Nate have DevOps Experience?"
        />

        {/* <button className={styles.button} onClick={executeAiCall}>
          {' '}
          Ask Question
        </button> */}
        <LoadingButton text="Ask Question" onClick={executeAiCall} />
      </div>
      {/* {error ? <div className={styles.isNotPalindrome}>{error}</div> : ''} */}
      {messages.length > 0 ? (
        messages.map((message, index) => (
          <ChatBubble
            key={index}
            message={message.message}
            side={message.side}
            type={message.type}
          />
        ))
      ) : (
        <div className={styles.placeholder}></div>
      )}
      {/* {callMade ? (
        <p className={styles.isPalindrome}>{aiResponse}</p>
      ) : (
        <div className={styles.placeholder}></div>
      )} */}
    </div>
  );
}

export default ChatAI;
